import React, { useState } from "react";
import { useDeclared } from "../../../../Hooks/Features/Pocker/useDeclared"
import { useCommon } from "../../../../Hooks/Common/useCommon";
import { Calendar } from "primereact/calendar";
import CommonGrid from "../../../../components/CommonCompo/CommonGrid/CommonGrid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Pagination from "../../../../components/CommonCompo/Pagination/pagination";
import { Dialog } from "primereact/dialog";
import RevokePopup from "../../../../components/Poker/RevokePopup";
import ConfigColumn from "../../../../components/Poker/ConfigColumn";
import CommonFilterDropdown from "../../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown";
import TaskDetailsPopup from "../../../../components/TaskList/TaskDetailsPopup";

const Declared = () => {

    const { checkPermission } = useCommon();
    const { tagRef, handleFilterChange, options, columns, rowData, loader, getDeclareDetails, pagination, setPagination, revoke, setRevoke, bidsDetails, setBidDetails, historyCols, setCommonFilter, commonFilter, projectWiseData, expanded, setExpanded, configColumn, setConfigColumn, getWeightMetricsFormula, getValuePermission, filterValues, setFilterValues, taskDetailsPopup, setTaskDetailsPopup} = useDeclared();
    const [showFiltersDrawer,setShowFiltersDrawer] = useState(false)

    return (
        <div ref={() => checkPermission("Estimate", tagRef)}>
            <div ref={tagRef} id='{"tabname": "bucket_planning", "data": "agileplanning_estimation_tab"}' >
                <div className="d-flex justify-content-between align-items-center my-3 px-3 gap-3 header-row">
                    <div className="d-flex gap-3 align-items-center flex-grow-1">
                        <h5 className="mb-0">Declare</h5>
                        
                        {/* Flow Type Segmented Control */}
                        <div className="sk-segment-control" style={{ maxWidth: "220px" }}>
                            <button
                                type="button"
                                className={`sk-segment-btn ${commonFilter?.taskType ? 'active' : ''}`}
                                onClick={() => { setCommonFilter({ ...commonFilter, taskType: true, callApi: true }) }}
                            >
                                Agile Flow
                            </button>
                            <button
                                type="button"
                                className={`sk-segment-btn ${!commonFilter?.taskType ? 'active' : ''}`}
                                onClick={() => { setCommonFilter({ ...commonFilter, taskType: false, callApi: true }) }}
                            >
                                Direct
                            </button>
                        </div>

                        {/* Calendar */}
                        <div className="inspectra-calendar" style={{ width: "140px" }}>
                            <Calendar className="input-dd" placeholder="Select Month" view="month" onChange={(e) => {
                                setCommonFilter({ ...commonFilter, month: e.target?.value ? e.target?.value : null, isChange: true })
                            }}
                                value={commonFilter?.month ? new Date(commonFilter?.month) : null} onHide={() => { if (commonFilter?.isChange) { getDeclareDetails(); setCommonFilter({ ...commonFilter, isChange: false }) } }} dateFormat="mm-yy" />
                        </div>

                        {/* Issue Key Input */}
                        <div style={{ width: "140px" }}>
                            <input type="text" className="input-dd w100 mb-0" placeholder="Issue key..."
                                value={commonFilter?.issueKey}
                                onChange={(e) => { setCommonFilter({ ...commonFilter, issueKey: e.target?.value, isChange: true }) }} onBlur={() => { if (commonFilter?.isChange) { getDeclareDetails(); setCommonFilter({ ...commonFilter, isChange: false }) } }} />
                        </div>

                        {commonFilter?.totalTasks !== undefined && (
                            <span className="fw-semibold text-muted">{commonFilter?.totalTasks} Tasks</span>
                        )}
                    </div>
                    <div className="d-flex justify-content-end align-items-center gap-2">
                        <button data-icon-only="true" data-action-type="default" onClick={() => getDeclareDetails()} title="Refresh"><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
                        <button data-icon-only="true" data-action-type="default" onClick={() => setShowFiltersDrawer(true)} title="Filters"><FontAwesomeIcon icon="fa-solid fa-filter" /></button>
                        {
                            !getValuePermission("config_declare_columns") && (
                                <button data-icon-only="true" data-action-type="default" onClick={() => setConfigColumn((prev) => ({ ...prev, visible: true }))} title="Settings">
                                    <FontAwesomeIcon icon="fa-solid fa-gear" />
                                </button>
                            )
                        }
                        {
                            expanded ? (
                                <button title="Collapse All" data-icon-only="true" data-action-type="default" onClick={() => setExpanded(false)}>
                                    <FontAwesomeIcon icon="fa-solid fa-list" />
                                </button>
                            ) : (
                                <button title="Expand All" data-icon-only="true" data-action-type="default" onClick={() => setExpanded(true)}>
                                    <FontAwesomeIcon icon="fa-solid fa-expand" />
                                </button>
                            )
                        }
                    </div>
                </div>
                <div className="mt-2 w100" style={{ height: "calc(100vh - 145px)", overflow: "auto" }}>
                    <CommonGrid columns={columns} data={rowData} expandAll={expanded} loader={loader} headerHeight={50} />
                </div>
                <Pagination totalRecords={pagination?.total_records} totalPages={pagination?.total_pages} currentPage={pagination?.current_page} displayPageOutOfTotal={pagination?.display_page_out_of_total} onPageChange={(e) => {
                    setPagination((prev) => ({ ...prev, current_page: e }));
                    setCommonFilter({ ...commonFilter, callApi: true })
                }} />

                {revoke?.show && <RevokePopup showPopup={revoke} handleClose={() => setRevoke((prev) => ({ ...prev, show: false, data: [] }))} stage="finalized" apiCall={() => { getDeclareDetails(); setRevoke((prev) => ({ ...prev, show: false, data: [] })) }} />}

                <Dialog visible={bidsDetails?.visible} onHide={() => setBidDetails((prev) => ({ ...prev, visible: false, data: [], winner: 0 }))} className="modal-large" style={{ maxWidth: "60vw", width: "60vw" }} draggable={false} header={`Bid History for ${bidsDetails?.data?.[0]?.issue_key}`}>
                    <div>
                        <CommonGrid columns={historyCols} data={[{ id: "all", title: "", children: bidsDetails?.data }]} expandAll={true} headerHeight={50} />
                    </div>
                </Dialog>
                {
                    configColumn?.visible && <ConfigColumn configColumnPopup={configColumn} setConfigColumnPopup={setConfigColumn} getWeightMetricsFormula={getWeightMetricsFormula} />
                }
                {taskDetailsPopup?.show &&
                    <Dialog visible={taskDetailsPopup?.show} draggable={false} style={{ height: "85vh", width: "70rem", maxWidth: "70rem" }} className='modal-xlarge task-details' onHide={() => setTaskDetailsPopup((prev) => ({ ...prev, show: false }))}>
                        <TaskDetailsPopup setTaskDetailsPopup={setTaskDetailsPopup} data={taskDetailsPopup?.data || { project_id: 0 }} />
                    </Dialog>
                }
            </div>

            {/* Right Panel Filters Drawer */}
            <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
                <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
                    <div className="sk-drawer-header">
                        <h5 className="sk-drawer-title">Filters</h5>
                        <div className="d-flex align-items-center gap-2">
                            <button className="sk-drawer-clear-btn" onClick={() => {
                                setCommonFilter({
                                    ...commonFilter,
                                    projects: [],
                                    sprint: [],
                                    issueType: [],
                                    subProject: [],
                                    reporters: [],
                                    month: null,
                                    taskType: true,
                                    isChange: true
                                });
                            }}>Clear All</button>
                            <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                                <FontAwesomeIcon icon="fa-solid fa-xmark" />
                            </button>
                        </div>
                    </div>
                    <div className="sk-drawer-body">
                        <div className='d-flex flex-column gap-4'>
                            {/* Flow Type Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Flow Type</div>
                                <div className="sk-segment-control mb-3">
                                    <button type="button" className={`sk-segment-btn ${commonFilter?.taskType ? 'active' : ''}`} onClick={() => { setCommonFilter({ ...commonFilter, taskType: true, callApi: true }); }}>Agile Flow</button>
                                    <button type="button" className={`sk-segment-btn ${!commonFilter?.taskType ? 'active' : ''}`} onClick={() => { setCommonFilter({ ...commonFilter, taskType: false, callApi: true }); }}>Direct</button>
                                </div>
                            </div>

                            {/* Calendar/Month Filter */}
                            <div className="sk-drawer-filter-group inspectra-calendar">
                                <div className="task-list-filter-label">Select Month</div>
                                <Calendar className="input-dd w-100" placeholder="Select Month" view="month" onChange={(e) => {
                                    setCommonFilter({ ...commonFilter, month: e.target?.value ? e.target?.value : null, isChange: true })
                                }}
                                    value={commonFilter?.month ? new Date(commonFilter?.month) : null} onHide={() => { if (commonFilter?.isChange) { getDeclareDetails(); setCommonFilter({ ...commonFilter, isChange: false }) } }} dateFormat="mm-yy" />
                            </div>

                            {/* Dimensions Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Dimensions</div>
                                <CommonFilterDropdown
                                    fields={[
                                        { key: "projects", label: "Projects", col: 12, optionValue: "project_id", onHide: () => handleFilterChange() },
                                        { key: "sprint", label: "Sprint", col: 12, optionValue: "sprint_id", options: projectWiseData?.sprint, onHide: () => getDeclareDetails() },
                                        { key: "issueType", label: "Task Type", col: 12, optionValue: "issue_type_id", options: projectWiseData?.issueType, onHide: () => getDeclareDetails() },
                                        { key: "subProject", label: "Sub Project", col: 12, optionValue: "option_id", options: projectWiseData?.subProject, onHide: () => getDeclareDetails() },
                                        { key: "reporters", label: "Reporters", col: 12, optionValue: "reporter_user_code", options: projectWiseData?.reporters, onHide: () => getDeclareDetails() }
                                    ]}
                                    filterValues={commonFilter}
                                    setFilterValues={setCommonFilter}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="sk-drawer-footer">
                        <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
                            getDeclareDetails();
                            setShowFiltersDrawer(false);
                        }}>Apply Filters</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Declared